export default {
  'cart:title': 'Winkelwagen',
  'cart:sub-title': '{value} artikelen',
  'cart:top-message-1': 'Goede keuze!',
  'cart:top-message-2': 'Hier zijn je producten',
  'cart:available-payment-methods': 'Wij accepteren',
  'cart:available-payment-methods-2': 'Veilig betalen met',
  'cart:empty:title': 'Je winkelwagen is leeg.',
  'cart:empty:description':
    'Blader door onze shop en vind lekkere en gezonde diervoeding voor je viervoeter.',
  'cart:empty:description-test':
    'Ben je nog op zoek naar het juiste voer? Probeer eens onze voeradviseur.',
  'cart:empty:button': 'Naar de voeradviseur',
  'cart:product:interval': 'Levering',
  'cart:minimum-basket-value': 'Minimale bestelwaarde',
  'cart:free-shipping-notice':
    'Nog <span>{insufficientMoney}</span> tot <span>gratis verzending</span>',
  'cart:free-shipping-notice-test': 'Nog {insufficientMoney} tot gratis verzending',
  'cart:summary:shipping:free': 'Gratis',
  'cart:summary:shipping:free-test': '<div><span>4,90 €</span> 0,00 €</div>',
  'cart:summary:shipping:min-price': 'vanaf {price}',
  'cart:empty:dogs-button': 'VOOR HONDEN',
  'cart:empty:cats-button': 'VOOR KATTEN',
  'cart:mbv:notice-text': 'Benodigd bedrag om de minimale bestelwaarde te bereiken',
  'cart:mbv:notice-text-test':
    'De minimale bestelwaarde is {mov}. Er ontbreekt nog {insufficientMoney}',
  'cart:mbv:cta-text': 'Waarom wij een minimale bestelwaarde hanteren bij diepvriesbestellingen',
  'cart:mbv:modal:title': "Minimale bestelwaarde bij verse menu's",
  'cart:mbv:modal:description': `
    <p>
      Houd er rekening mee dat er bij bestellingen die diepgevroren producten bevatten een minimale bestelwaarde van 30 € geldt.
    </p>
    {br}
    <p>
      De resterende <b>{insufficientMoney}</b> kun je aanvullen met producten naar keuze. Ken je onze hoogwaardige BARF-aanvullingen al, zoals onze Mineral-Mix of een van onze oliën?
    <p/>
  `,
  'cart:mbv:modal:cta': 'Nu verder shoppen',
  'cart:sub-total': 'Subtotaal incl. BTW',
  'cart:items-total': 'Som van de artikelen',
  'cart:sub-total-with-disscounts': 'Subtotaal incl. korting',
  'cart:tiny-cart:sub-total': 'Subtotaal <span>incl. BTW</span>',
  'cart:tiny-cart:sub-total-with-disscounts': 'Subtotaal<span>na kortingen incl. BTW</span>',
  'cart:savings': 'Je bespaart',
  'cart:savings:total': 'Totale besparing',
  'cart:savings:subscription': 'Bespaarabonnement',
  'cart:savings:referal': 'Vrienden werven vrienden',
  'cart:savings:credit': 'Pets Deli tegoed',
  'cart:savings:offer': 'Aanbieding',
  'cart:savings:yearly-savings-by-plan': 'Jaarvoordeel {planName}',
  'cart:savings:offer:savings-plan:clever': 'Jaarvoordeel Clever',
  'cart:savings:offer:savings-plan:premium': 'Jaarvoordeel Premium',
  'cart:savings:coupon': 'Cadeaubon {couponCode}',
  'cart:total': 'Totaalbedrag',
  'cart:total:incl-vat': 'Totaal incl. BTW',
  'cart:tax': 'incl. BTW',
  'cart:tax:with-shipping': 'incl. BTW & verzending',
  'cart:tax:with-free-shipping': 'incl. BTW & gratis verzending',
  'cart:shipping': 'Verzending',
  'cart:shipping:costs': 'Leveringskosten',
  'cart:shipping:new-customer': 'Verzending <span>(Gratis voor nieuwe klanten)</span>',
  'cart:shipping:existing-customer': 'Verzending <span>(Gratis vanaf 60 €)</span>',
  'cart:go-to-checkout': 'Afrekenen',
  'cart:gift-items:title': 'Verzeker je van maximaal 4 cadeaus',
  'cart:gift-items:free': 'Gratis',
  'cart:preorder-shipping-delay-title': 'Let op',
  'cart:preorder-mixed-shipping-delay':
    'De verzending van de adventskalenders vindt plaats vanaf oktober 2020. De rest van je bestelling wordt direct verwerkt en bezorgd.',
  'cart:preorder-only-shipping-delay':
    'De verzending van de adventskalenders vindt plaats vanaf oktober 2020. Verheug je erop!',
  'cart:discount:Referal': 'Vrienden werven vrienden',
  'cart:discount:Credit': 'Pets Deli tegoed',
  'cart:discount:Coupon': 'Pets Deli cadeaubon',
  'cart:discount:Custom': 'Pets Deli cadeaubon',
  'cart:discount-error:referal:ItemsTotalToSmall':
    'Benodigd bedrag om de vrienden-werven-korting te krijgen',
  'cart:discount-error:referal:ItemsTotalToSmall-test':
    'Benodigd bedrag om de vrienden-werven-korting te krijgen {insufficientMoney}',
  'cart:discount-error:referal:InvalidReferal':
    'Ongeldige referentiecode. Neem contact op met de klantenservice als je denkt dat dit een fout is.',

  'cart:interval-selection:regular-delivery': 'Regelmatige levering',
  'cart:interval-selection:activate-subscription': 'Abonnement activeren',
  'cart:interval-selection:order-type': 'Levering',
  'cart:interval-selection:one-off': 'Eenmalig',
  'cart:interval-selection:deactivate-subscription': 'Geen abonnement',

  'cart:subs-info-modal:header': 'HET PETS DELI VOERABONNEMENT',
  'cart:subs-info-modal:instruction:point-1': 'Zoek gewoon je favoriete producten in de shop',
  'cart:subs-overlay:title': 'Pas het abonnement zo aan dat het het beste bij je past',
  'cart:subs-overlay:accept-selection': 'Selectie accepteren',
  'cart:subs-info-modal:instruction:point-2': "Kies op de productpagina's formaat & aantal",
  'cart:subs-info-modal:instruction:point-3':
    'Regelmatige levering activeren & leveringsinterval instellen',
  'cart:subs-info-modal:instruction:point-4': 'Bestel zoals gewoonlijk...klaar!',
  'cart:subs-info-modal:benefits:header': 'GEMAKKELIJK, FLEXIBEL, RISICOVRIJ!',
  'cart:subs-info-modal:benefits:point-1': 'Geen minimale contractduur',
  'cart:subs-info-modal:benefits:point-2': 'Op elk moment zelf opzegbaar',
  'cart:subs-info-modal:benefits:point-3': 'Blijvend {discount}% besparen bij elke levering',
  'cart:subs-info-modal:benefits:point-4':
    'Wijziging van het leveringsinterval en pauzeren van het abonnement op elk moment mogelijk',

  'cart:summary:pay-also-with': 'Of direct betalen met',
  'cart:summary:pay-also-with-test': 'Of',
  'cart:summary:button:express-checkout-mobile': 'Express Checkout',

  'cart:gift-selection:header': 'Verzeker je van een gratis cadeau van Pets Deli',
  'cart:gift-selection:message:part-1': 'Vanaf een',
  'cart:gift-selection:message:part-2': 'aankoopwaarde van',
  'cart:gift-selection:message:part-3': ' krijg je een gratis cadeau van ons bij je bestelling.',
  'cart:gift-selection:header-with-gift': 'Je gratis cadeau van Pets Deli',

  'cart:money-back:title': '30-dagen Smaakgarantie 😋',
  'cart:money-back:sub-title':
    'Wij bieden je een gratis vooralternatief aan, mocht het niet smaken.',
  'cart:money-back:modal:title': 'Pets Deli lost voerproblemen op - aantoonbaar.',
  'cart:money-back:modal:sub-title':
    'Ons motto: <b>Smaakt niet, bestaat niet!</b> Mocht het je viervoeter tegen de verwachting in toch niet smaken, dan krijg je van ons een gratis vooralternatief.',
  'cart:money-back:modal:list-title': 'Zo eenvoudig gaat het:',
  'cart:money-back:modal:step-1':
    'Vul gewoon ons contactformulier in, dat je hier vindt. Gebruik bij een probleem alsjeblieft “Smaakgarantie” <a>Verzoek indienen - PETS DELI</a>',
  'cart:money-back:modal:step-2':
    'Ontvang een gratis voeradvies van onze voedingsexperts, om het juiste alternatieve product passend bij jullie behoeften te vinden.',
  'cart:money-back:modal:step-3':
    'Wij zorgen ervoor dat je je nieuwe product zo snel mogelijk toegestuurd krijgt.',

  'cart:upsell-product:title': 'Pssst - deze aanbieding is alleen voor jou!',
  'cart:upsell-product:title-profile-no-name': 'Kleine verrassing voor je viervoeter?',
  'cart:upsell-product:title-profile-with-name': 'Kleine verrassing voor {petName}?',
  'cart:upsell-product:cta': 'Meebestellen',
  'cart:upsell-product:cta-item-added': 'Toegevoegd',
  // PT-4103 Frontend :: A/B test :: Improve Voucher Redemption Communication
  // https://petsdeli.atlassian.net/browse/PT-4103
  'cart:coupon:successfully-applied':
    'De coupon {couponCode} is succesvol opgeslagen en wordt toegepast bij het afrekenen.',
  'cart:coupon:successfully-applied-variant:close': 'Sluiten',

  'cart:discount-modal:greeting': `we hebben een hete deal voor je!`,
  'cart:discount-modal:title': 'Speciaal voor jou',
  'cart:discount-modal:discount': '<span>{percentage}%</span> op {category}',
  'cart:discount-modal:category:supplements': 'Voedingssupplementen',
  'cart:discount-modal:category:snacks': 'Snacks',
  'cart:discount-modal:category:snacks:subsscription': 'Snacks met de regelmatige levering',
  'cart:discount-modal:category:mov': 'vanaf 40€ bestelwaarde',
  'cart:discount-modal:category:cta:discover-offers': 'TOPAANBIEDINGEN ONTDEKKEN',
  'cart:discount-modal:category:cta:add-snacks': 'Snacks toevoegen',
  'cart:discount-modal:category:cta:subscribe-snacks': 'SNACKS ABONNEREN',
  'cart:discount-modal:category:cta:go-to-checkout': 'Verder naar afrekenen',

  'cart:coupon-modal-pop-up:successfully-applied':
    '<p>Gefeliciteerd!</p>Je cadeaubon <strong> {couponCode} </strong> is ingewisseld.',
  'cart:coupon-modal-pop-up:minimum-order-value': 'vanaf {miniminumOrderValue}€ bestelwaarde',

  'cart:subs-reminder-modal-pop-up:title': 'Slim bespaard met een abonnement!',
  'cart:subs-reminder-modal-pop-up:title:success': 'Gelukt',
  'cart:subs-reminder-modal-pop-up:title:success:text':
    'Yay! Je hebt zojuist <br></br> <span></span> <br></br> bespaard!',
  'cart:subs-reminder-modal-pop-up:title:success:info-text':
    'Je kunt je abonnement in de winkelwagen of na het betalen in je account bewerken.',
  'cart:subs-reminder-modal-pop-up:sub-title:scenario':
    'Doe het regelmatig en bespaar <span></span> met een abonnement!',
  'cart:subs-reminder-modal-pop-up:info-abo':
    'Abonnement <b>op elk moment flexibel</b> aanpassen, pauzeren & opzeggen',
  'cart:subs-reminder-modal-pop-up:interval-selector:title': 'Kies je leveringsinterval',
  'cart:subs-reminder-modal-pop-up:info-abo:show-all-button': 'Toon alles',
  'cart:subs-reminder-modal-pop-up:CTA1': 'Abonneren en besparen',
  'cart:subs-reminder-modal-pop-up:CTA2': 'Verder naar afrekenen',
  'cart:subs-reminder-modal-pop-up:go-to-checkout': 'Nu betalen',

  'cart:apple-pay-modal:title': 'Apple Pay Error',
  'cart:apple-pay-modal:content': 'Er is iets misgegaan! Probeer het alsjeblieft nog een keer.',

  'cart:modal-discount-selector:title': 'Maak alsjeblieft een keuze',
  'cart:modal-discount-selector:info:credits-and-coupon':
    'Het Pets Deli tegoed en de cadeaubon {couponCode} zijn aan je winkelwagen toegevoegd. Beide kunnen echter niet voor één aankoop worden gebruikt. Kies alsjeblieft de optie die je wilt gebruiken.',
  'cart:modal-discount-selector:info:referal-and-coupon':
    'De vrienden-werven-bonus en de cadeaubon BF30 zijn aan je winkelwagen toegevoegd. Beide kunnen echter niet voor één aankoop worden gebruikt. Kies alsjeblieft de optie die je wilt gebruiken.',
  'cart:modal-discount-selector:credits:title': 'Pets Deli tegoed',
  'cart:modal-discount-selector:credits:cta': 'Tegoed gebruiken',
  'cart:modal-discount-selector:coupon:title': 'Cadeaubon',
  'cart:modal-discount-selector:coupon:titl-with-coupon': 'Cadeaubon {couponCode}',
  'cart:modal-discount-selector:coupon:cta': 'Cadeaubon gebruiken',
  'cart:modal-discount-selector:referal:title': 'Vrienden-werven-bonus',
  'cart:modal-discount-selector:referal:cta': 'Bonus gebruiken',
  'cart:oos-modal:title': 'Oeps, sommige producten zijn uitverkocht',
  'cart:oos-modal:subtitle':
    '{itemsCount, plural, one {We moeten het volgende product uit de winkelwagen verwijderen, omdat het niet meer op voorraad is.} other {We moeten de volgende producten uit de winkelwagen verwijderen, omdat ze niet meer op voorraad zijn.}}',
  'cart:oos-modal:cta:continue-shopping': 'Verder winkelen',
  'cart:oos-modal:cta:go-to-checkout': 'Afrekenen',

  'cart:low-rate-subscription-modal:very-low:title': 'Heb je een abonnement aangemaakt?',
  'cart:low-rate-subscription-modal:very-low:description':
    'Het lijkt erop dat je producten in de winkelwagen hebt geabonneerd*. Was dat de bedoeling?<span>*Voor het abonnement geldt een minimale bestelwaarde van {amount}.</span>',
  'cart:low-rate-subscription-modal:very-low:cta:primary': 'Abonnement opzeggen en afrekenen',
  'cart:low-rate-subscription-modal:very-low:cta:secondary': 'Abonnement verhogen naar {amount}',
  'cart:low-rate-subscription-modal:low:title': 'Meer abonneren, meer besparen!',
  'cart:low-rate-subscription-modal:low:description':
    'Voor het abonnement geldt een minimale bestelwaarde van {amount}. Voeg alsjeblieft meer artikelen toe om deze te bereiken.',
  'cart:low-rate-subscription-modal:low:cta:primary': 'Abonnement verhogen naar {amount}',
  'cart:low-rate-subscription-modal:low:cta:secondary': 'Abonnement opzeggen en afrekenen',
  'cart:low-rate-subscription-modal:note':
    'Abonnement <span>op elk moment flexibel</span> aanpassen, pauzeren & opzeggen',
  'cart:low-rate-subscription:group:title:success': 'Nu kun je abonneren en geld besparen! 🥳',
  'cart:low-rate-subscription:group:title:missing-amount':
    'Voeg alsjeblieft nog {amount} toe voor het abonnement.',
  'cart:low-rate-subscription:modal-info:title': 'Je besparing bij elke bestelling',
  'cart:low-rate-subscription:modal-info:original-price': 'Originele prijs incl. BTW',
  'cart:low-rate-subscription:modal-info:subscription-discount': 'Korting regelmatige levering',
  'cart:low-rate-subscription:modal-info:coupon-discount': 'Cadeaubon {couponCode}',
  'cart:low-rate-subscription:modal-info:total-price': 'Jouw prijs incl. BTW',
  'cart:price-details-modal:original-price': 'Originele prijs incl. BTW',
  'cart:price-details-modal:total-price': 'Jouw prijs incl. BTW',
  'cart:low-rate-subscription:modal-info-note':
    'Abonnement vanaf <span>{amount} minimale bestelwaarde.</span> Minder leveringen helpen <span>emissies te verlagen.</span>',
  'cart:tiny-cart:urgency-note': 'Je producten worden slechts {minutes} minuten gereserveerd',

  // cart:pet-profile-modal
  // step 1
  'cart:pet-profile-modal:step-1:image:alt':
    'Kat en hond knuffelen – extra korting en een glimlach.',
  'cart:pet-profile-modal:step-1:sheet-title:extra-discount': 'Verzeker je van extra korting!',
  'cart:pet-profile-modal:step-1:sheet-text:extra-discount':
    'Help ons het beste voer voor je viervoeters te vinden – vul nu het dierprofiel in.',
  'cart:pet-profile-modal:step-1:sheet-button:ignore-discount': 'Korting vergeten',
  'cart:pet-profile-modal:step-1:sheet-button:cancel': 'Terug',
  'cart:pet-profile-modal:step-1:sheet-button:lets-go': 'Aan de slag',
  // step 3
  'cart:pet-profile-modal:step-3:sheet-title:image:alt': 'Lachende bulldog',
  'cart:pet-profile-modal:step-3:sheet-title:create-another':
    'Super! Extra korting & passende aanbevelingen geactiveerd. Nog een viervoeter?',
  'cart:pet-profile-modal:step-3:button:ja': 'Ja',
  'cart:pet-profile-modal:step-3:button:nein': 'Nee',

  // cart:dynamic-bundle
  'cart:dynamic-bundle:title:personal-sample-box': 'Persoonlijke proefbox',
  'cart:dynamic-bundle:thin-message:box-content': 'Inhoud van de box',
  'cart:dynamic-bundle:box-content-count': '{count} producten',
  'cart:dynamic-bundle:one-more-cat': 'Nog een kat?',
  'cart:dynamic-bundle:one-more-dog':
    'Nog een hond in de roedel? Voeg nog een persoonlijke proefbox toe.',
  'cart:dynamic-bundle:add-box': 'Box toevoegen',
};
